import {
  DialogContent,
  Dialog,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import "../i18n/config";
import { ChangeEvent, useState } from "react";
import { useTranslation } from "react-i18next";

type ModalNicknameProps = {
  isOpen: boolean;
  close: () => void;
  save: (name: string) => void;
};

export const ModalNickname = (props: ModalNicknameProps) => {
  const { isOpen, close, save } = props;
  const { t } = useTranslation();
  const [name, setName] = useState<string>("");

  return (
    <Dialog
      PaperProps={{ style: { height: "255px" } }}
      open={isOpen}
      onClose={close}
    >
      <DialogTitle>
        <Typography>{t(`exported.Edit your Team Nick Name`)}</Typography>
      </DialogTitle>
      <DialogContent style={{ paddingTop: "4px" }}>
        <TextField
          fullWidth
          label={t("exported.Edit your Team Nick Name")}
          value={name}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setName(event.target.value);
          }}
        />
      </DialogContent>
      <DialogActions style={{ padding: "0 24px" }}>
        <Button key={0} variant="text" onClick={close}>
          {t("exported.Cancel")}
        </Button>
        ,
        <Button key={1} onClick={() => save(name)}>
          {t("exported.Save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalNickname;
